module.exports = __webpack_public_path__ + "img/jewellery.42937af.webp";